import { useCallback } from "react";
import { useQueryClient } from "react-query";
import { PROFILE_QUERY_KEY } from "./queryKeys";

const useInvalidateProfileQuery = () => {
    const queryClient = useQueryClient();

    return useCallback(() => {
        queryClient.invalidateQueries(PROFILE_QUERY_KEY);
    }, [queryClient]);
};

export default useInvalidateProfileQuery;
